import { EntityDataStore } from '@skinsoft/entity-data-store';

export interface ThesaurusTerm {
    id: string;
}

export interface ThesaurusTermWithParents {
    parentTerms: ThesaurusTerm[],
    term: ThesaurusTerm
}

export class ThesaurusTermDataStore extends EntityDataStore<ThesaurusTerm> {
    public static getInstance() {
        if (!ThesaurusTermDataStore.instance) {
            ThesaurusTermDataStore.instance = new ThesaurusTermDataStore();
        }

        return ThesaurusTermDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$thesaurusTermDataStore = ThesaurusTermDataStore.getInstance();
    }

    private static instance: ThesaurusTermDataStore = null as any;

    constructor() {
        super('thesaurusTerm', ['ThesaurusTerm']);
    }

    public fetchChildren(id: string, locale: string, page: number = 0, size: number = 100) {
        return this.fetchAll({
            endpoint: `/thesaurusTerm/${id}/children?page=${page}&size=${size}&lang=${locale}`,
        });
    }

    public fetchRoot(id: string) {
        return this.fetchAll({
            endpoint: '/thesaurusTerm/root',
            query: {
                entity: id,
                institution: localStorage.getItem('institution')
            },
        });
    }
}
